import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class CollectionDashboardChart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [30, 70],
      options: {
        labels: ["Lead", "Contacts"],
        colors:["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="320"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default CollectionDashboardChart
